import { styled } from 'styled-components';

export const CardContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
